/* eslint-disable */
import React from "react";
import { alpha, styled } from "@mui/material/styles";
import {
  TreeItem,
  TreeView,
} from "views/pages/manage/common/commonComponents/tree";
import CustomTreeItemAdded from "./CustomTreeItemAdded";
import { MinusSquare, PlusSquare, CloseSquare } from "./SvgIcon";
import { ReactComponent as HorizontalLine } from "../../../../../../assets/img/svg/HorizontalLine.svg";

const StyledTreeItem = styled((props) => (
  <TreeItem ContentComponent={CustomTreeItemAdded} {...props} />
))(({ theme }) => ({
  // [`& .${treeItemClasses.group}`]: {
  //   marginLeft: 15,
  //   paddingLeft: 10,
  //   borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.2)}`,
  // },
}));

export default function TreeViewByAdd({
  subjectChapters,
  setSubjectChapters,
  addHandler,
  expended,
  deleteHandler,
}) {
  return (
    <TreeView
      aria-label="customized"
      defaultCollapseIcon={<MinusSquare />}
      defaultExpandIcon={<PlusSquare />}
      defaultEndIcon={<CloseSquare />}
      sx={{ flexGrow: 1, overflowY: "auto" }}
    >
      {subjectChapters?.tableOfContent?.map((chapter) => (
        <StyledTreeItem
          key={chapter.key}
          nodeId={chapter.key.toString()}
          label={chapter.title}
          onClick={{ data: chapter, mutator: deleteHandler }}
        >
          {chapter?.children?.map((topic) => (
            <StyledTreeItem
              key={topic.key}
              nodeId={topic.key.toString()}
              label={topic.title}
              onClick={{
                data: { ...topic },
                mutator: deleteHandler,
              }}
            >
              {topic?.children?.map((subtopic) => (
                <StyledTreeItem
                  key={subtopic.key}
                  nodeId={subtopic.key.toString()}
                  label={subtopic.title}
                  onClick={{
                    data: {
                      ...subtopic,
                      topicParentId: chapter.key,
                    },
                    mutator: deleteHandler,
                  }}
                  // Leaf sub-topics (no children) get the dash icon.
                  // Sub-topics WITH children get default +/- so they can expand.
                  icon={
                    !subtopic?.children?.length ? <HorizontalLine /> : undefined
                  }
                >
                  {subtopic?.children?.map((subsubtopic) => (
                    <StyledTreeItem
                      key={subsubtopic.key}
                      nodeId={subsubtopic.key.toString()}
                      label={subsubtopic.title}
                      onClick={{
                        data: {
                          ...subsubtopic,
                          parentNode: subtopic.key,
                          topicParentId: topic.key,
                          chapterParentId: chapter.key,
                        },
                        mutator: deleteHandler,
                      }}
                      icon={<HorizontalLine />}
                    />
                  ))}
                </StyledTreeItem>
              ))}
            </StyledTreeItem>
          ))}
        </StyledTreeItem>
      ))}
    </TreeView>
  );
}
